function accordian(){
  const wrappers = document.querySelectorAll(".accordio-wrapper");
  wrappers.forEach((wrapper) => {
    const accordions = wrapper.querySelectorAll(".accordian-wrap");
    let currentIndex = 0;
    const openAccordion = (accordion) => {
      const content = accordion.querySelector(".accordian-content");
      accordion.classList.add("active");
      content.style.maxHeight =
        accordion.querySelector(".accordian-content-inr").scrollHeight + "px";
    };
    const closeAccordion = (accordion) => {
      const content = accordion.querySelector(".accordian-content");
      accordion.classList.remove("active");
      content.style.maxHeight = null;
    };
    if (accordions[0]) openAccordion(accordions[0]);
    accordions.forEach((accordion, index) => {
      const intro = accordion.querySelector(".accordian-title");
      const content = accordion.querySelector(".accordian-content");
      intro.onclick = () => {
        const isOpen = accordion.classList.contains("active");
        currentIndex = index;
        if (isOpen) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((acc) => closeAccordion(acc));
          openAccordion(accordion);
        }
      };
    });
/*
setInterval(() => {
  currentIndex = (currentIndex + 1) % accordions.length;
  accordions.forEach((acc) => closeAccordion(acc));
  openAccordion(accordions[currentIndex]);
}, 5000);
*/
  });
}

accordian();
document.addEventListener("shopify:section:load", accordian);
document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelectorAll('.contact-btn')) document.querySelectorAll('.contact-btn').forEach(function(contact_btn){
    contact_btn.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.add('active-contact');
    });
  });
  if(document.querySelectorAll('.contact-pop-up-overlay,.contact-close')) document.querySelectorAll('.contact-pop-up-overlay,.contact-close').forEach(function(contact_overlay){
    contact_overlay.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.remove('active-contact');
    });
  });
  if(document.querySelectorAll('.request-btn')) document.querySelectorAll('.request-btn').forEach(function(request_btn){
    request_btn.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.add('active-request');
    });
  });
  if(document.querySelectorAll('.request-pop-up-overlay,.request-close')) document.querySelectorAll('.request-pop-up-overlay,.request-close').forEach(function(request_overlay){
    request_overlay.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.remove('active-request');
    });
  });
  if(document.querySelectorAll('.request-invit-btn')) document.querySelectorAll('.request-invit-btn').forEach(function(request_btn){
    request_btn.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.add('active-request-invit');
    });
  });
  if(document.querySelectorAll('.request-invitpop-up-overlay,.request-invit-close')) document.querySelectorAll('.request-invit-pop-up-overlay,.request-invit-close').forEach(function(request_overlay){
    request_overlay.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.remove('active-request-invit');
    });
  });
  if(document.querySelectorAll('.receive-btn')) document.querySelectorAll('.receive-btn').forEach(function(receive_btn){
    receive_btn.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.add('active-receive');
    });
  });
  if(document.querySelectorAll('.receive-pop-up-overlay,.receive-close')) document.querySelectorAll('.receive-pop-up-overlay,.receive-close').forEach(function(receive_overlay){
    receive_overlay.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.remove('active-receive');
    });
  });
    if(document.querySelectorAll('.fcs-btn')) document.querySelectorAll('.fcs-btn').forEach(function(fcs_btn){
    fcs_btn.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.add('active-fcs');
    });
  });
  if(document.querySelectorAll('.fcs-pop-up-overlay,.fcs-close')) document.querySelectorAll('.fcs-pop-up-overlay,.fcs-close').forEach(function(fcs_overlay){
    fcs_overlay.addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.remove('active-fcs');
    });
  });
  if(document.querySelectorAll('.field-select-wrap')) document.querySelectorAll('.field-select-wrap').forEach(item => {
    let ftr_cont = item.querySelector('.field-select');
    ftr_cont.style.maxHeight = '0';
    if(item.querySelector('.field-select-btn')) item.querySelector('.field-select-btn').addEventListener('click', (e) => {
      e.preventDefault();
      let isOpen = item.classList.contains('active');
      document.querySelectorAll('.field-select-wrap').forEach(otherItem => {
        if(otherItem !== item){
          let otherContent = otherItem.querySelector('.field-select');
          otherItem.classList.remove('active');
          otherContent.style.maxHeight = '0';
        }
      });
      if(!isOpen){
        item.classList.add('active');
        ftr_cont.style.maxHeight = `${ftr_cont.querySelector('ul').offsetHeight}px`;
      }else{
        item.classList.remove('active');
        ftr_cont.style.maxHeight = '0';
      }
    });
  });
  // document.querySelectorAll('.field-select-wrap').forEach(function(wrap){
  //   let fieldSelect = wrap.querySelector('.field-select');
  //   let activeItems = [...fieldSelect.querySelectorAll('a.active')].map(a =>
  //     a.getAttribute('data-name').trim()
  //   );
  //   wrap.dataset.selectedOrder = JSON.stringify(activeItems);
  //   wrap.querySelectorAll('ul a').forEach(function(option){
  //     option.addEventListener('click', function(e){
  //       e.preventDefault();
  //       let input = wrap.querySelector('input');
  //       let buttonSpan = wrap.querySelector('.field-select-btn span');
  //       let name = option.getAttribute('data-name').trim();
  //       option.classList.toggle('active');
  //       let selectedOrder = JSON.parse(wrap.dataset.selectedOrder || "[]");
  //       if(option.classList.contains('active')){
  //         selectedOrder.push(name);
  //       }else{
  //         selectedOrder = selectedOrder.filter(item => item !== name);
  //       }
  //       wrap.dataset.selectedOrder = JSON.stringify(selectedOrder);
  //       input.value = selectedOrder.join(', ');
  //       buttonSpan.textContent = selectedOrder.length ? selectedOrder.join(', ') : 'Select';
  //       fieldSelect.style.maxHeight = fieldSelect.scrollHeight + 'px';
  //     });
  //   });
  // });
  document.querySelectorAll('.field-select-wrap').forEach(function (wrap) {
    const fieldSelect = wrap.querySelector('.field-select');
    const isMultiple = wrap.dataset.select === 'multiple';

    // Init selected order
    let activeItems = [...fieldSelect.querySelectorAll('a.active')].map(a =>
      a.getAttribute('data-name').trim()
    );
    wrap.dataset.selectedOrder = JSON.stringify(activeItems);

    wrap.querySelectorAll('ul a').forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();

        const input = wrap.querySelector('input');
        const buttonSpan = wrap.querySelector('.field-select-btn span');
        const name = option.getAttribute('data-name').trim();

        let selectedOrder = JSON.parse(wrap.dataset.selectedOrder || '[]');

        if (isMultiple) {
          // MULTIPLE SELECT (existing behavior)
          option.classList.toggle('active');

          if (option.classList.contains('active')) {
            selectedOrder.push(name);
          } else {
            selectedOrder = selectedOrder.filter(item => item !== name);
          }
        } else {
          // SINGLE SELECT
          wrap.querySelectorAll('ul a.active').forEach(a => a.classList.remove('active'));
          option.classList.add('active');
          selectedOrder = [name];
        }

        wrap.dataset.selectedOrder = JSON.stringify(selectedOrder);
        input.value = selectedOrder.join(', ');
        buttonSpan.textContent = selectedOrder.length ? selectedOrder.join(', ') : 'Select';

        fieldSelect.style.maxHeight = fieldSelect.scrollHeight + 'px';
      });
    });
  });

  // let options = document.querySelectorAll('.field-select-wrap ul a');
  // if(options.length){
  //   options.forEach(function(select_wrap) {
  //     select_wrap.addEventListener('click', function(e) {
  //       e.preventDefault();
  //       let fieldWrap = select_wrap.closest('.field-select-wrap');
  //       let fieldSelect = select_wrap.closest('.field-select');
  //       let input = fieldSelect.querySelector('input');
  //       let selectedName = select_wrap.getAttribute('data-name');

  //       fieldWrap.querySelector('.field-select-btn').classList.add('active');
  //       fieldWrap.querySelector('.field-select-btn span').textContent = selectedName.replaceAll('-', ' ');

  //       input.value = selectedName;

  //       fieldWrap.classList.remove('active');
  //       fieldSelect.style.maxHeight = '0';
  //     });
  //   });
  // }
});
document.addEventListener('DOMContentLoaded', function(){
  const formsConfig = [
    { formId: 'ContactForm', btnSelector: '.con-submit-btn' },
    { formId: 'RequestForm', btnSelector: '.req-submit-btn' },
    { formId: 'fcsForm', btnSelector: '.fcs-submit-btn' }
  ];
  formsConfig.forEach(({ formId, btnSelector }) => {
    const form = document.getElementById(formId);
    const submitBtns = document.querySelectorAll(btnSelector);
    if (!form || !submitBtns.length) return;
    submitBtns.forEach(btn => {
      btn.addEventListener('click', function (e) {
        let valid = true;
        const requiredInputs = form.querySelectorAll('input[type="text"]');
        requiredInputs.forEach(input => {
          if (!input.value.trim()) {
            valid = false;
            input.classList.add('error');
          } else {
            input.classList.remove('error');
          }
        });
        const email = form.querySelector('input[type="email"], #'+formId+'-email');
        if (email) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(email.value.trim())) {
            valid = false;
            email.classList.add('error');
          } else {
            email.classList.remove('error');
          }
        }
        const selectWraps = form.querySelectorAll('.field-select-wrap');
        selectWraps.forEach(wrap => {
          const hidden = wrap.querySelector('.field-select input[type="hidden"]');
          if (!hidden) return;

          if (!hidden.value.trim()) {
            valid = false;
            wrap.classList.add('error');
          } else {
            wrap.classList.remove('error');
          }
        });
        const checkbox = form.querySelector('input[type="checkbox"][required]');
        if (checkbox && !checkbox.checked) {
          valid = false;
          checkbox.classList.add('error');
        } else if (checkbox) {
          checkbox.classList.remove('error');
        }
        if (!valid) {
          e.preventDefault();
        } else {
          form.submit();
        }
      });
    });
    form.querySelectorAll('input').forEach(field => {
      field.addEventListener('input', function () {
        if (this.value.trim()) this.classList.remove('error');
      });
    });
    form.querySelectorAll('.field-select-wrap').forEach(wrap => {
      wrap.addEventListener('click', function () {
        const hidden = wrap.querySelector('.field-select input[type="hidden"]');
        if (hidden && hidden.value.trim()) wrap.classList.remove('error');
      });
    });
    const checkbox = form.querySelector('input[type="checkbox"][required]');
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (this.checked) this.classList.remove('error');
      });
    }
  });
});
function homeTop(){
  var footer = document.querySelector("footer").offsetHeight;
  document.querySelector("#shopify-section-footer").style.minHeight = footer + "px";
}
document.addEventListener("DOMContentLoaded", homeTop);
window.addEventListener("resize", homeTop);
function updateHeaderTheme(){
  const header = document.querySelector('.section-header');
  if (!header) return;
  const headerRect = header.getBoundingClientRect();
  const headerHeight = headerRect.height;
  const sections = document.querySelectorAll('section');
  let darkPixels = 0;
  let lightPixels = 0;
  sections.forEach(section => {
    const rect = section.getBoundingClientRect();
    const overlap = Math.min(headerRect.bottom, rect.bottom) - Math.max(headerRect.top, rect.top);
    if (overlap > 0){
      if(section.classList.contains('dark-nav')){
        darkPixels += overlap;
      }else{
        lightPixels += overlap;
      }
    }
  });
  const isDark = darkPixels > (headerHeight / 2);
  header.classList.toggle('dark-header', isDark);
}
document.addEventListener('DOMContentLoaded', updateHeaderTheme);
window.addEventListener('scroll', updateHeaderTheme);
// document.querySelectorAll('.button').forEach(btn => {
//   btn.addEventListener('click', () => {
//     btn.classList.add('focus');
//     setTimeout(() => {
//       btn.classList.remove('focus');
//     }, 500);
//   });
// });
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('active-contact','active-request');
  }
};


document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll("section");

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  const observerOptions = {
    threshold: isMobile ? 0.01 : 0.05,
    rootMargin: isMobile ? "0px 0px -5% 0px" : "0px"
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  elements.forEach(el => observer.observe(el));
});
// document.addEventListener("DOMContentLoaded", () => {
//   const elements = document.querySelectorAll("section");
//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if(entry.isIntersecting){
//         entry.target.classList.add("is-visible");
//         observer.unobserve(entry.target);
//       }
//     });
//   }, { threshold: 0.15 });
//   elements.forEach(el => observer.observe(el));
// });
if(document.querySelector('.header-nav ul')){
  document.querySelectorAll('.header-nav ul > .menu-item').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active-menu');
      if(navList.querySelector('.mega-menu-wrap')){
        let height = (navList.querySelector('.mega-menu-wrap').offsetHeight - 5);
        if(document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly')) document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly').style.height = height+'px';
        setTimeout(() => {
          if(document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly')) document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly').classList.add('active');
        }, 200);
      }
    });
    navList.addEventListener('mousemove', function(){
      navList.classList.add('active-menu');
      if(navList.querySelector('.mega-menu-wrap')){
        let height = (navList.querySelector('.mega-menu-wrap').offsetHeight - 5);
        if(document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly')) document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly').style.height = height+'px';
        setTimeout(() => {
          if(document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly')) document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly').classList.add('active');
        }, 200);
      }
    });
    navList.addEventListener('mouseout', function(){
      document.querySelector('.header-menu-overly').style.height = '';
      setTimeout(() => {
        if(document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly')) document.querySelector('.header-nav:has(.menu-item.active-menu) .header-menu-overly').classList.remove('active');
      }, 200);
      navList.classList.remove('active-menu');
    });
  });
}
if(document.querySelector('.menu-burdger')) document.querySelector('.menu-burdger').addEventListener('click',function(e){
  e.preventDefault();
  document.body.classList.toggle('open-menu');
  if(document.body.classList.contains('open-menu')){
    document.querySelector('.snippet-menu-drawer').style.maxHeight = document.querySelector('.menu-drawer-inner').offsetHeight + 'px';
  }else{
    document.querySelector('.snippet-menu-drawer').style.maxHeight = '';
  }
})
if(document.querySelectorAll('.md-menu-icon-drop').length) document.querySelectorAll('.md-menu-icon-drop').forEach(function (menu_icon) {
  menu_icon.addEventListener('click', function(e){
    e.preventDefault();
    let currentItem = menu_icon.closest('.menu-item');
    let isOpen = currentItem.classList.contains('open-submenu');
    document.querySelectorAll('.menu-item.open-submenu').forEach(function (item) {
      item.classList.remove('open-submenu');
      item.querySelector('.mega-menu-wrap').style.maxHeight = '';
    });
    if(!isOpen){
      currentItem.classList.add('open-submenu');
      document.querySelector('.snippet-menu-drawer').style.maxHeight = (document.querySelector('.menu-drawer-inner').offsetHeight + currentItem.querySelector('.mega-inner').offsetHeight) + 'px';
      currentItem.querySelector('.mega-menu-wrap').style.maxHeight = currentItem.querySelector('.mega-inner').offsetHeight + 'px';
    }else{
      document.querySelector('.snippet-menu-drawer').style.maxHeight = document.querySelector('.menu-drawer-inner').offsetHeight + 'px';
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const medias = document.querySelectorAll(".media img, .media video, .media picture");

  let ticking = false;

  function updateParallax() {
    const windowHeight = window.innerHeight;

    medias.forEach(media => {
      const rect = media.getBoundingClientRect();

      if (rect.bottom > -windowHeight && rect.top < windowHeight * 2) {

        let speed = 0.04;

        if (
          media.closest(".section-banner-logo-heading") ||
          media.closest(".section-banner-subheading-heading")
        ) {
          speed = 0.10;
        }

        const offset = (rect.top - windowHeight / 2) * -speed;
        media.style.transform = `translate3d(0, ${offset}px, 0)`;
      }
    });

    ticking = false;
  }

  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  });

  updateParallax();
});

document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector('.page-landing-page-fcs, .page-landing-page-padel')){
    const sections = document.querySelectorAll("main .shopify-section");
    const lastSection = sections[sections.length - 1];
console.log(sections,'---',lastSection);
    if (!lastSection) return;

    function checkLastSection() {
      const rect = lastSection.getBoundingClientRect();

      // jyare last section nu bottom viewport na bottom karta upar ke equal hoy
      if (rect.bottom <= window.innerHeight) {
        document.body.classList.add("active-corner");
      } else {
        document.body.classList.remove("active-corner");
      }
    }

    window.addEventListener("scroll", checkLastSection);
    window.addEventListener("resize", checkLastSection);

    checkLastSection(); // initial load check
  }
});